var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 131,
    viewBox: "0 0 132 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2131"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 86",
    cx: 65.2852,
    cy: 65,
    r: 59,
    fill: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: " ",
    d: "M49.2842 76.3892C51.4531 78.588 54.0419 80.3348 56.899 81.5273C59.7561 82.7198 62.824 83.3341 65.9231 83.3341C69.0222 83.3341 72.0901 82.7198 74.9472 81.5273C77.8043 80.3348 80.3931 78.588 82.5621 76.3892",
    stroke: "#00368E",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 261",
    cx: 49.2852,
    cy: 55,
    r: 5,
    fill: "#00368E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 262",
    cx: 82.2852,
    cy: 55,
    r: 5,
    fill: "#00368E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/defaultProfile.5711e63eadad2caaffd5ba1ce8a56c21.svg";
export { ForwardRef as ReactComponent };